import { createContext, PropsWithChildren, useContext, useState } from 'react';

interface ErrorContext {
  errorMessage: string;
  setErrorMessage: (message: string) => void;
  clearError: () => void;
}

const ErrorContext = createContext<ErrorContext | null>(null);

export const ErrorProvider = ({ children }: PropsWithChildren) => {
  const [errorMessage, setErrorMessage] = useState('');

  const clearError = () => {
    setErrorMessage('');
  };

  return (
    <ErrorContext.Provider
      value={{ errorMessage, setErrorMessage, clearError }}
    >
      {children}
    </ErrorContext.Provider>
  );
};

export const useErrorContext = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useErrorContext must be used within a ErrorProvider');
  }
  return context;
};
